import UsersTable from "../ui/uiElements/UsersTable.component";
import Loader from "../ui/Spinner.component";
import { getRegisRequests } from "../services/admin.service";
import { useQuery } from "@tanstack/react-query";
import { Alert } from "react-bootstrap";
import ErrorPage from "../ui/ErrorPage.component";

function RegistrationRequests() {
  const {
    isLoading,
    data: users,
    error,
  } = useQuery({
    queryKey: ["RegisUsers"],
    queryFn: getRegisRequests,
  });

  if (isLoading) return <Loader />;

  if (error) return <ErrorPage errorCode="500" description="Something went wrong , please try again later" />;

  return (
    <div>
      <h3>Registration Requests</h3>
      <hr />
      {users.length === 0 ? (
        <Alert variant="dark">No registration requests yet</Alert>
      ) : (
        <UsersTable users={users} type="requests" />
      )}
    </div>
  );
}

export default RegistrationRequests;
